import { Grid, Paper } from "@mui/material";
import DOMPurify from 'dompurify';
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { IEventView } from "../../_common/interface/event/iEventView";
import { getStringDateNormalized } from "../../_helpers/dateTime.helper";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { eventService } from "../../_services/event.service";
import { eventUserService } from "../../_services/eventUser.service";

export function UserProfileEventView() {
    const resetData = () => ({
        id: 0,
        name: '',
        description: '',
        eventDate: ''
    });
    const navigate = useNavigate();
    const { userId, eventId } = useParams<{ userId: string, eventId: string }>();

    const [data, setData] = useState<IEventView>(resetData);
    const [isLoading, setLoading] = useState(false);
    const [isSaving, setSaving] = useState(false);
    const [sanitizedHtml, setSanitizedHtml] = useState<string>("")

    useEffect(() => {
        if (!!eventId)
            fetchData();
        else
            setData(resetData);
    }, [eventId]);

    function fetchData() {
        if (!eventId) return;
        setLoading(true);
        return eventService
            .get(Number(eventId), userId)
            .then(
                (json) => {
                    setSanitizedHtml(DOMPurify.sanitize(json.description));
                    setData(json)
                }
            )
            .finally(() => setLoading(false));
    }

    function joinCompetition() {
        if (!eventId) return;
        setLoading(true);
        return eventUserService
            .post(Number(eventId))
            .then(
                (json) => {
                    navigate("/Users/" + userId + "/UserCart/" + json.userCartId);
                }, handleErrorResponse
            )
            .finally(() => setLoading(false));
    }


    return (
        <>
            <h2 style={{ textAlign: "center" }}>Event: {data.name}</h2>
            <Paper>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        Event Date: <strong>{getStringDateNormalized(data.eventDate)}</strong>
                    </Grid>
                    <Grid item xs={12}>
                        Price: <strong>€{parseFloat((data.price || 0).toString()).toFixed(2)}</strong>
                    </Grid>
                    <Grid item xs={12}>
                        <div
                            dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
                        />
                    </Grid>

                    {/* <Grid item xs={12}>
                        {(!data.isPaid && (!data.userRole || data.userRole == EventUserRoleEnum.User)) &&
                            <PrimaryButton icon={"check"} isLoading={isLoading} isSaving={isSaving} onClick={joinCompetition} variant="success" type="button">Join the competition</PrimaryButton>
                        }

                        {(data.isPaid && data.userRole == EventUserRoleEnum.User) &&
                            <PrimaryButton icon={"check"} isLoading={isLoading} isSaving={isSaving} onClick={joinCompetition} variant="success" type="button" disabled>Already Joined This Competition</PrimaryButton>
                        }

                    </Grid> */}
                </Grid>
            </Paper>
        </>
    );
}